import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EventsIndex from './events/Index';
import EventsDetails from './events/Details';

export default function Events() {
  return (
    <div>
      <Routes>
        <Route path="" element={<EventsIndex />} />
        <Route path=":id" element={<EventDetailsRouter />} />
      </Routes>
    </div>
  );
}

function EventDetailsRouter() {
  // wrapper to read param and pass to component
  // avoid importing useParams at top-level to keep file tidy
  const { useParams } = require('react-router-dom');
  const params = useParams();
  return <EventsDetails id={params.id} />;
}
